import { useContext } from 'react'
import {
  PageVariationsContext,
  type PageVariationsContextType,
} from '@contexts/PageVariationsContext'

export const usePageVariations = (): PageVariationsContextType => {
  const contextValue = useContext(PageVariationsContext)

  if (contextValue === null) {
    throw new Error('No "PageVariationsProvider" configured')
  }

  return contextValue
}
